// React imports
import React, { useEffect, useRef, useState } from 'react';

// Router imports
import { Link } from 'react-router-dom';

// Redux imports
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

// Asset imports
import { ReactComponent as BuiltLogo } from '../../assets/built-logo.svg';
import Person from '../../assets/person.png';

// Component imports
import Button from './Button';
import SecondaryNavigation from './SecondaryNavigation';
import Text from './Text';

interface DesktopHeaderProps {
  isAuthenticated: boolean;
  navigate: (path: string) => void;
}

const DesktopHeader: React.FC<DesktopHeaderProps> = ({ isAuthenticated }) => {
  const user = useSelector((state: RootState) => state.user.userDetails);
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const menuRef = useRef<HTMLDivElement | null>(null);
  const buttonWrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        buttonWrapperRef.current &&
        !buttonWrapperRef.current.contains(event.target as Node)
      ) {
        setIsMenuVisible(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  return (
    <div
      className={`desktop-header d-flex align-items-center col-lg-8 px-lg-0 col-md-12 p-sm-3 col-sm-12 ${
        isAuthenticated ? 'justify-content-between' : 'justify-content-center'
      }`}
    >
      <div className="d-flex align-items-center gap-100">
        <div className="sign-in-logo">
          <Link to={isAuthenticated ? '/dashboard' : '/'}>
            <BuiltLogo fill="white" />
          </Link>
        </div>
        {isAuthenticated && (
          <div className="d-flex align-items-center gap-50">
            <Link className="header-link" to="/dashboard">
              <Text className="large-regular-bold">Ideas</Text>
            </Link>
            <Link className="header-link" to="/people">
              <Text className="large-regular-bold">People</Text>
            </Link>
          </div>
        )}
      </div>

      {isAuthenticated && (
        <div ref={buttonWrapperRef}>
          <Button
            type="button"
            className="person-button"
            onClick={toggleMenu}
            aria-label="Open profile menu"
          >
            <img src={Person} alt="person" className="person-logo" />
          </Button>
        </div>
      )}

      {isAuthenticated && isMenuVisible && user && (
        <div className="secondary-navigation-menu" ref={menuRef}>
          <SecondaryNavigation closeMenu={() => setIsMenuVisible(false)} />
        </div>
      )}
    </div>
  );
};

export default DesktopHeader;
